export class Financials {
  estimated: boolean;
  price_per_kg: number;
  quantity: number;
  total: number;
  payment_state: string;
  flow: string;

  constructor(data: any) {
    this.estimated = data.estimated;
    this.price_per_kg = data.price_per_kg;
    this.quantity = data.quantity;
    this.total = data.total;
    this.payment_state = data.payment_state;
    this.flow = data.flow;
  }
}

export class Debtor {
  firstname?: string;
  lastname?: string;
  organisation_name?: string;
  subdistrict?: string;
  transactor_id: number;

  constructor(data: any) {
    this.firstname = data.firstname;
    this.lastname = data.lastname;
    this.organisation_name = data.organisation_name;
    this.subdistrict = data.subdistrict;
    this.transactor_id = data.transactor_id;
  }
}

export class ParentContract {
  grade: string;
  id: number;

  constructor(data: any) {
    this.grade = data.grade;
    this.id = data.id;
  }
}

export class Transaction {
  id: number;
  transaction_date: string;
  party: string;
  title: string;
  statement_id?: number;
  source: string;
  status: string;
  type: string;
  financials: Financials;
  debtor: Debtor | null;
  parent_contract_details: ParentContract | null;

  constructor(data: any) {
    this.id = data.id;
    this.transaction_date = data.transaction_date;
    this.party = data.party;
    this.title = data.title;
    this.statement_id = data.statement_id;
    this.source = data.source;
    this.status = data.status;
    this.type = data.type;
    this.financials = new Financials(data.financials);
    this.debtor = data.debtor ? new Debtor(data.debtor) : null;
    this.parent_contract_details = data.parent_contract_details ? new ParentContract(data.parent_contract_details) : null;
  }

  isPayment(): boolean {
    return this.source === 'PAYMENT';
  }

  isContract(): boolean {
    return this.source === 'CONTRACT';
  }
}
